import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'

export function ServicesHeroSection() {
  return (
    <Section surface="0" className="pt-10 pb-10 sm:pt-16 sm:pb-14 md:pt-24 md:pb-20">
      <Container className="max-w-4xl">
        <span className="font-mono text-xs uppercase tracking-widest text-fg-muted mb-3 sm:mb-4 block">
          Solutions & Engineering
        </span>
        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-fg text-balance leading-tight">
          Technical Solutions Engineered for Precision.
        </h1>
        <p className="mt-4 sm:mt-6 text-sm sm:text-lg md:text-xl text-fg-subtle leading-relaxed">
          From full-scale enterprise applications and multi-tenant SaaS systems to specialized digital platforms — we design, code, and support systems built to scale.
        </p>
      </Container>
    </Section>
  )
}
